import {
  FETCH_SLOTS_REQUEST,
  FETCH_MORE_SLOTS_REQUEST,
  FETCH_SLOT_REQUEST,
  LOAD_UNBOOKED_SLOT,
  UPDATE_SLOT_FILTER,
  CANCEL_SLOT_REQUEST,
} from './slotsActionTypes';

export const fetchSlots = () => {
  return {
    type: FETCH_SLOTS_REQUEST,
  };
};

export const fetchMoreSlots = () => {
  return {
    type: FETCH_MORE_SLOTS_REQUEST,
  };
};

export const fetchSlot = (slotId) => {
  return {
    type: FETCH_SLOT_REQUEST,
    slotId,
  };
};

export const cancelSlot = ({ slotId, guestNote }) => {
  return {
    type: CANCEL_SLOT_REQUEST,
    slotId,
    guestNote,
  };
};

export const loadUnbookedSlot = (slot) => {
  return {
    type: LOAD_UNBOOKED_SLOT,
    slot,
  };
};

export const updateSlotFilter = (slotFilter) => {
  return {
    type: UPDATE_SLOT_FILTER,
    slotFilter,
  };
};
